<template>
  <el-table-column
    prop="status"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.status === 'recorded'" size="small" type="info">Rögzítve</el-tag>
      <el-tag v-if="scope.row.status === 'done'" size="small" type="success">Visszavéve</el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'status',
};
</script>
